import * as React from "react"

const FooterInformation = () => (
  <>
    <p className="uppercase">Contact Us</p>
    <div className="contact-information max-250 mla">
      <p className="email m0 flex">
        <span className="uppercase small mr20 lh2">E</span>
        <a className="link sainte" href="mailto:admin@lewisandtrovas.com">admin@lewisandtrovas.com</a>
      </p>

      <p className="uppercase mt20 mb10">Brisbane</p>
      <p className="phone m0">
        <span className="uppercase small mr20 lh2">T</span>
        <a className="link sainte" href="tel:+61733332858">+61 7 3333 2858</a>
      </p>
      <p className="address m0 flex">
        <span className="uppercase small mr20 lh2">A</span>
        <a className="link sainte max-200" href="https://www.google.com/maps/place/Level 7, 10 Market St Brisbane CBD QLD 4000" target="_blank" rel="noreferrer">Level 7, 10 Market St Brisbane CBD QLD 4000</a>
      </p>

      <p className="uppercase mt20 mb10">Sydney</p>
      <p className="phone m0">
        <span className="uppercase small mr20 lh2">T</span>
        <a className="link sainte" href="tel:+61291919268">+61 2 9191 9268</a>
      </p>
      <p className="address m0 flex">
        <span className="uppercase small mr20 lh2">A</span>
        <a className="link sainte max-200" href="https://www.google.com/maps/place/Level 6, 25 Bligh Street, Sydney CBD NSW 2000" target="_blank" rel="noreferrer">Level 6, 25 Bligh Street Sydney CBD NSW 2000</a>
      </p>
    </div>
  </>
)

export default FooterInformation
